import { da, de, enUS, es, fr, it, nl, nb, pl, ru, ro, pt } from "date-fns/locale";

// INFO: sequential is important!
const Languages = {
	en: "en",
	no: "no",
	de: "de",
	ru: "ru",
	pl: "pl",
	fr: "fr",
	es: "es",
	it: "it",
	da: "da",
	nl: "nl",
	ro: "ro",
	pt: "pt",
};

// INFO: sequential is important!
const locales = Object.keys(Languages);

const translateMatcher = {
	da: da,
	de: de,
	en: enUS,
	es: es,
	fr: fr,
	it: it,
	nl: nl,
	no: nb,
	pl: pl,
	ru: ru,
	ro: ro,
	pt: pt,
};

export { Languages, locales, translateMatcher };
